import styles from "./StatisticsPlanDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import {
  PaymentTypesLabels,
  StatisticDetailItemType,
  CommissionCategoryLabels,
} from "../../../common/labels";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { useNavigate } from "react-router-dom";
import { constructUserPlanHref } from "../../../common/infrastructure/routes/routePaths";
import { PriceDisplay } from "../../../common/components/PriceDisplay/PriceDisplay";

interface IStatisticsPlanDialogProps {
  item: IStatisticDetailedItemViewModel;
}

export const StatisticsPlanDialog = ({ item }: IStatisticsPlanDialogProps) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(constructUserPlanHref(item.id));
  };

  const getTransactionType = () => {
    if (!!item.additionalTypeInfo) {
      return `${StatisticDetailItemType[item.type]}, ${
        item.additionalTypeInfo
      }`;
    }

    return StatisticDetailItemType[item.type];
  };

  // The currency is no longer appended here — the amount itself carries it.
  const paymentTypeLabel = item.paymentType
    ? PaymentTypesLabels[item.paymentType]
    : "N/A";

  const hasCommission =
    item.commissionAmountInEur !== null &&
    item.commissionAmountInEur !== undefined;

  const commissionCategoryLabel =
    item.commissionCategory !== null && item.commissionCategory !== undefined
      ? CommissionCategoryLabels[item.commissionCategory]
      : "";

  const commissionPercentLabel =
    item.commissionPercent !== null && item.commissionPercent !== undefined
      ? `${item.commissionPercent}%`
      : "";

  const commissionTypeValue = [commissionCategoryLabel, commissionPercentLabel]
    .filter(Boolean)
    .join(" · ");

  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.userName} <span>(#{item.userId})</span>
          </h5>
          <p>
            Дата на плащане:{" "}
            <span>{dateUtility.formatDateTime(item.dateTime)}</span>
          </p>
        </div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"ПЛАН"}
          value={`${item.name} (#${item.id})`}
        />
        <StatisticsDialogKeyValueItem
          name={"ПЛАТЕНА СУМА"}
          value={
            !!item.pricePaid ? (
              <PriceDisplay
                minPrice={item.pricePaid}
                currencyId={item.currencyId}
              />
            ) : (
              "N/A"
            )
          }
        />
        <StatisticsDialogKeyValueItem
          name={"НАЧИН НА ПЛАЩАНЕ"}
          value={paymentTypeLabel}
        />
        <StatisticsDialogKeyValueItem
          name={"ТИП ТРАНЗАКЦИЯ"}
          value={getTransactionType()}
        />
        {hasCommission && (
          <>
            <StatisticsDialogKeyValueItem
              name={"КОМИСИОНЕН ПРОЦЕНТ"}
              value={commissionTypeValue || "—"}
            />
            <StatisticsDialogKeyValueItem
              name={"СПЕЧЕЛЕНА КОМИСИОННА"}
              value={`€ ${(item.commissionAmountInEur ?? 0).toFixed(2)}`}
            />
          </>
        )}
      </div>
    </div>
  );
};
